import { selectedVideoRate } from "./data/media-provider-pricing.js";
export * from "./data/media-provider-pricing.js";
import { getTtsModelOption, ttsModelOptions, isElevenLabsModelId, } from "./data/voice-options.js";
let runtimeModelCreditCosts = null;
export function setRuntimeModelCreditCosts(config) {
    runtimeModelCreditCosts = config;
}
export function getRuntimeModelCreditCosts() {
    return runtimeModelCreditCosts;
}
export const facelessMotionVideoResolutions = [
    "720p",
    "1080p",
];
export const defaultFacelessMotionVideoModelId = "kwaivgi/kling-v3.0-omni";
export const defaultFacelessMotionVideoResolution = "720p";
export const defaultFacelessMotionClipDurationSeconds = 5;
export const facelessMotionVideoModelOptions = [
    {
        description: "Good baseline quality at 720p.",
        id: "kwaivgi/kling-video-o1",
        label: "Kling Video O1",
        priceUsdPerSecondByResolution: {
            "720p": 0.112,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [5, 10],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p"],
    },
    {
        description: "Lower-cost Kling v3 model for 720p portrait video.",
        id: "kwaivgi/kling-v3.0-std",
        label: "Kling 3.0 Standard",
        priceUsdPerSecondByResolution: {
            "720p": 0.084,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p"],
    },
    {
        description: "Higher-quality Kling v3 model for 720p portrait video.",
        id: "kwaivgi/kling-v3.0-pro",
        label: "Kling 3.0 Pro",
        priceUsdPerSecondByResolution: {
            "720p": 0.112,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p"],
    },
    {
        description: "Long-form Seedance model with strong reference-guided continuity.",
        id: "bytedance/seedance-2.5",
        label: "Seedance 2.5",
        priceUsdPerSecondByResolution: {
            "720p": 0.23112,
        },
        supportedAspectRatios: ["16:9", "4:3", "1:1", "3:4", "9:16", "21:9"],
        supportedDurations: [
            4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
            22, 23, 24, 25, 26, 27, 28, 29, 30,
        ],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p"],
        supportsReferenceImages: true,
    },
    {
        description: "Lowest-cost Seedance 2 model for high-volume portrait reels.",
        id: "bytedance/seedance-2.0-mini",
        label: "Seedance 2.0 Mini",
        priceUsdPerSecondByResolution: {
            "720p": 0.0756,
        },
        supportedAspectRatios: ["1:1", "3:4", "9:16", "4:3", "16:9", "21:9", "9:21"],
        supportedDurations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p"],
        supportsReferenceImages: true,
    },
    {
        description: "ByteDance's highest-quality model for detailed, consistent motion.",
        id: "bytedance/seedance-2.0",
        label: "Seedance 2.0",
        priceUsdPerSecondByResolution: {
            "720p": 0.1512,
            "1080p": 0.3402,
        },
        supportedAspectRatios: ["1:1", "3:4", "9:16", "4:3", "16:9", "21:9", "9:21"],
        supportedDurations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        description: "Cinematic image animation with strong motion and prompt adherence.",
        id: "runway/gen-4.5",
        label: "Runway Gen-4.5",
        priceUsdPerSecondByResolution: {
            "720p": 0.12,
        },
        supportedAspectRatios: ["16:9", "9:16"],
        supportedDurations: [2, 3, 4, 5, 6, 7, 8, 9, 10],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p"],
    },
    {
        description: "Alibaba model with smooth motion and consistent characters.",
        id: "alibaba/happyhorse-1.1",
        label: "HappyHorse 1.1",
        priceUsdPerSecondByResolution: {
            "720p": 0.0988,
            "1080p": 0.1278,
        },
        supportedAspectRatios: ["16:9", "9:16", "1:1", "4:3", "3:4", "21:9", "9:21"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
    },
    {
        description: "Alibaba model for flexible image-driven portrait animation.",
        id: "alibaba/happyhorse-1.0",
        label: "HappyHorse 1.0",
        priceUsdPerSecondByResolution: {
            "720p": 0.0988,
            "1080p": 0.1694,
        },
        supportedAspectRatios: ["16:9", "9:16", "1:1", "4:3", "3:4", "21:9", "9:21"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
    },
    {
        description: "Faster, lower-cost Seedance 2.0 for rapid iterations.",
        id: "bytedance/seedance-2.0-fast",
        label: "Seedance 2.0 Fast",
        priceUsdPerSecondByResolution: {
            "720p": 0.12096,
        },
        supportedAspectRatios: ["1:1", "3:4", "9:16", "4:3", "16:9", "21:9", "9:21"],
        supportedDurations: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p"],
        supportsReferenceImages: true,
    },
    {
        description: "Cost-effective Seedance model with native audiovisual generation.",
        id: "bytedance/seedance-1-5-pro",
        label: "Seedance 1.5 Pro",
        priceUsdPerSecondByResolution: {
            "720p": 0.02592,
            "1080p": 0.05832,
        },
        supportedAspectRatios: ["1:1", "3:4", "9:16", "9:21", "4:3", "16:9", "21:9"],
        supportedDurations: [4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        description: "Alibaba model for long, reference-guided portrait video.",
        id: "alibaba/wan-3.0",
        label: "Wan 3.0",
        priceUsdPerSecondByResolution: {
            "720p": 0.1,
            "1080p": 0.2,
        },
        supportedAspectRatios: ["16:9", "4:3", "1:1", "3:4", "9:16"],
        supportedDurations: [
            2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
            21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        ],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        description: "Alibaba model with separate 720p and 1080p image-to-video pricing.",
        id: "alibaba/wan-2.6",
        label: "Wan 2.6",
        priceUsdPerSecondByResolution: {
            "720p": 0.1,
            "1080p": 0.15,
        },
        supportedAspectRatios: ["9:16", "16:9"],
        supportedDurations: [5, 10],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
    },
    {
        description: "Alibaba image-to-video model with flexible portrait outputs.",
        id: "alibaba/wan-2.7",
        label: "Wan 2.7",
        priceUsdPerSecondByResolution: {
            "720p": 0.1,
            "1080p": 0.1,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1", "4:3", "3:4"],
        supportedDurations: [2, 3, 4, 5, 6, 7, 8, 9, 10],
        supportedFrameImages: ["first_frame", "last_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        description: "Higher-resolution Grok model for detailed portrait motion.",
        id: "x-ai/grok-imagine-video-1.5",
        inputCreditsPerScene: 1,
        label: "Grok Imagine Video 1.5",
        priceUsdPerSecondByResolution: {
            "720p": 0.14,
            "1080p": 0.25,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1", "4:3", "3:4", "3:2", "2:3"],
        supportedDurations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
    },
    {
        description: "Lower-cost Grok video model. 1080p output is made from 720p video.",
        id: "x-ai/grok-imagine-video-1.5-lite",
        inputCreditsPerScene: 1,
        label: "Grok Imagine Video 1.5 Lite",
        priceUsdPerSecondByResolution: {
            "720p": 0.03,
            "1080p": 0.14,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1", "4:3", "3:4", "3:2", "2:3"],
        supportedDurations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
    },
    {
        description: "xAI first-frame video model with 720p portrait output.",
        id: "x-ai/grok-imagine-video",
        inputCreditsPerScene: 0.2,
        label: "Grok Imagine Video",
        priceUsdPerSecondByResolution: {
            "720p": 0.07,
        },
        supportedAspectRatios: ["9:16", "16:9", "1:1", "4:3", "3:4", "3:2", "2:3"],
        supportedDurations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p"],
    },
    {
        id: "pixverse/pixverse-v6",
        label: "PixVerse V6",
        description: "Flexible image animation and reference images.",
        provider: "kie",
        providerUrl: "https://kie.ai/pixverse-v6",
        priceUsdPerSecondByResolution: { "720p": 0.036, "1080p": 0.072 },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        id: "vidu/vidu-q4",
        label: "Vidu Q4",
        description: "Detailed image animation with flexible clip lengths.",
        provider: "kie",
        providerUrl: "https://kie.ai/vidu-q4",
        priceUsdPerSecondByResolution: { "720p": 0.076, "1080p": 0.096 },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        id: "kwaivgi/kling-v3.0-omni",
        label: "Kling 3.0 Omni",
        description: "Cinematic motion with image and character references.",
        provider: "kie",
        providerUrl: "https://kie.ai/kling-o3",
        priceUsdPerSecondByResolution: { "720p": 0.0755, "1080p": 0.101 },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
    {
        id: "kwaivgi/kling-v3.0-turbo",
        label: "Kling 3.0 Turbo",
        description: "Fast cinematic animation from a first-frame image.",
        provider: "kie",
        providerUrl: "https://kie.ai/kling-3-0-turbo",
        priceUsdPerSecondByResolution: { "720p": 0.101, "1080p": 0.126 },
        supportedAspectRatios: ["9:16", "16:9", "1:1"],
        supportedDurations: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
    },
    {
        id: "google/gemini-omni-1.1-flash",
        label: "Gemini Omni 1.1 Flash",
        description: "Portrait video from a first frame or reference images.",
        provider: "kie",
        providerUrl: "https://kie.ai/gemini-omni-1-1-flash",
        basePriceUsd: 0.105,
        defaultCreditsPerSecond: 8,
        priceUsdPerSecondByResolution: { "720p": 0.0525, "1080p": 0.0525 },
        supportedAspectRatios: ["9:16", "16:9"],
        supportedDurations: [4, 6, 8, 10],
        supportedFrameImages: ["first_frame"],
        supportedResolutions: ["720p", "1080p"],
        supportsReferenceImages: true,
    },
];
export function isFacelessMotionVideoModelId(value) {
    return (typeof value === "string" &&
        facelessMotionVideoModelOptions.some((option) => option.id === value));
}
export function isFacelessMotionVideoResolution(value) {
    return (typeof value === "string" &&
        facelessMotionVideoResolutions.includes(value));
}
export function getFacelessMotionVideoModelOption(modelId) {
    return (facelessMotionVideoModelOptions.find((option) => option.id === modelId) ??
        null);
}
export function supportsFacelessReferenceVideo(modelId) {
    return Boolean(getFacelessMotionVideoModelOption(modelId)
        ?.supportsReferenceImages);
}
export function getFacelessMotionVideoResolutionSize(resolution) {
    return resolution === "1080p" ? "1080x1920" : "720x1280";
}
export function pickNearestFacelessMotionDurationSeconds(requestedSeconds, supportedDurations) {
    const uniqueSorted = [...new Set(supportedDurations)]
        .filter((duration) => Number.isFinite(duration) && duration > 0)
        .sort((a, b) => a - b);
    if (uniqueSorted.length === 0) {
        return requestedSeconds;
    }
    let chosen = uniqueSorted[0] ?? requestedSeconds;
    let minDistance = Math.abs((chosen ?? requestedSeconds) - requestedSeconds);
    for (const duration of uniqueSorted) {
        const distance = Math.abs(duration - requestedSeconds);
        if (distance < minDistance) {
            chosen = duration;
            minDistance = distance;
        }
    }
    return chosen ?? requestedSeconds;
}
export function pickCoveringFacelessMotionDurationSeconds(requestedSeconds, supportedDurations) {
    const uniqueSorted = [...new Set(supportedDurations)]
        .filter((duration) => Number.isFinite(duration) && duration > 0)
        .sort((a, b) => a - b);
    const requested = Number.isFinite(requestedSeconds) && requestedSeconds > 0
        ? requestedSeconds
        : defaultFacelessMotionClipDurationSeconds;
    if (uniqueSorted.length === 0) {
        return requested;
    }
    for (const duration of uniqueSorted) {
        if (duration >= requested) {
            return duration;
        }
    }
    return uniqueSorted[uniqueSorted.length - 1] ?? requested;
}
export function supportsFacelessMotionVideoSettings(input) {
    const model = getFacelessMotionVideoModelOption(input.modelId);
    return Boolean(model &&
        model.supportedAspectRatios.includes("9:16") &&
        model.supportedResolutions.includes(input.resolution));
}
export function getFacelessMotionVideoCreditsPerScene(input) {
    const model = (input.modelId
        ? getFacelessMotionVideoModelOption(input.modelId)
        : null) ??
        getFacelessMotionVideoModelOption(defaultFacelessMotionVideoModelId);
    const defaultModel = getFacelessMotionVideoModelOption(defaultFacelessMotionVideoModelId);
    const resolution = input.resolution ?? defaultFacelessMotionVideoResolution;
    const configuredCreditsPerSecond = model
        ? runtimeModelCreditCosts?.videoCreditsPerSecond[model.id]?.[resolution]
        : undefined;
    const priceUsdPerSecond = model?.priceUsdPerSecondByResolution[resolution] ??
        model?.priceUsdPerSecondByResolution[defaultFacelessMotionVideoResolution] ??
        defaultModel?.priceUsdPerSecondByResolution[defaultFacelessMotionVideoResolution];
    if (typeof priceUsdPerSecond === "number") {
        const durationSeconds = typeof input.durationSeconds === "number" &&
            Number.isFinite(input.durationSeconds) &&
            input.durationSeconds > 0
            ? pickCoveringFacelessMotionDurationSeconds(input.durationSeconds, model?.supportedDurations ?? [])
            : pickNearestFacelessMotionDurationSeconds(defaultFacelessMotionClipDurationSeconds, model?.supportedDurations ?? []);
        return roundCredits((typeof configuredCreditsPerSecond === "number"
            ? configuredCreditsPerSecond
            : model?.defaultCreditsPerSecond ?? selectedVideoRate(model?.id ?? defaultFacelessMotionVideoModelId, resolution, priceUsdPerSecond) * 100) * durationSeconds +
            (input.includeImageInput === false
                ? 0
                : (model
                    ? runtimeModelCreditCosts?.videoInputCreditsPerScene[model.id]
                    : undefined) ??
                    model?.inputCreditsPerScene ??
                    0));
    }
    return 0;
}
function roundCredits(value) {
    return Math.round(value * 1_000_000) / 1_000_000;
}
export function retimeCaptionWordsForEditedText(originalWords, editedCaptionText) {
    const validOriginalWords = originalWords.filter((word) => word.text.trim().length > 0 &&
        Number.isFinite(word.startMs) &&
        Number.isFinite(word.endMs));
    const editedWords = splitCaptionTextIntoWords(editedCaptionText);
    if (validOriginalWords.length === 0 || editedWords.length === 0) {
        return [];
    }
    if (validOriginalWords.length === editedWords.length) {
        return editedWords.map((text, index) => copyCaptionTiming(validOriginalWords[index], text));
    }
    const matches = findCaptionTimingMatches(validOriginalWords, editedWords);
    if (matches.length === 0) {
        return editedWords.map((text, index) => {
            const fallbackIndex = Math.min(index, validOriginalWords.length - 1);
            return copyCaptionTiming(validOriginalWords[fallbackIndex], text);
        });
    }
    const retimedWords = [];
    let previousOriginalIndex = -1;
    let previousEditedIndex = -1;
    for (const match of matches) {
        appendCaptionTimingGap({
            editedWords,
            endEditedIndex: match.editedIndex,
            endOriginalIndex: match.originalIndex,
            originalWords: validOriginalWords,
            previousEditedIndex,
            previousOriginalIndex,
            retimedWords,
        });
        retimedWords.push(copyCaptionTiming(validOriginalWords[match.originalIndex], editedWords[match.editedIndex] ?? ""));
        previousOriginalIndex = match.originalIndex;
        previousEditedIndex = match.editedIndex;
    }
    appendCaptionTimingGap({
        editedWords,
        endEditedIndex: editedWords.length,
        endOriginalIndex: validOriginalWords.length,
        originalWords: validOriginalWords,
        previousEditedIndex,
        previousOriginalIndex,
        retimedWords,
    });
    return retimedWords;
}
function splitCaptionTextIntoWords(value) {
    return value.trim().split(/\s+/u).filter(Boolean);
}
function normalizeCaptionTimingWord(value) {
    return value
        .trim()
        .toLocaleLowerCase()
        .replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, "");
}
function copyCaptionTiming(originalWord, text) {
    return {
        endMs: originalWord?.endMs ?? 0,
        startMs: originalWord?.startMs ?? 0,
        text,
    };
}
function findCaptionTimingMatches(originalWords, editedWords) {
    const originalNormalized = originalWords.map((word) => normalizeCaptionTimingWord(word.text));
    const editedNormalized = editedWords.map(normalizeCaptionTimingWord);
    const rows = originalWords.length + 1;
    const columns = editedWords.length + 1;
    const lengths = Array.from({ length: rows }, () => Array(columns).fill(0));
    for (let originalIndex = originalWords.length - 1; originalIndex >= 0; originalIndex -= 1) {
        for (let editedIndex = editedWords.length - 1; editedIndex >= 0; editedIndex -= 1) {
            if (originalNormalized[originalIndex] &&
                originalNormalized[originalIndex] === editedNormalized[editedIndex]) {
                const nextDiagonalLength = lengths[originalIndex + 1]?.[editedIndex + 1] ?? 0;
                const row = lengths[originalIndex];
                if (row) {
                    row[editedIndex] = nextDiagonalLength + 1;
                }
            }
            else {
                const nextOriginalLength = lengths[originalIndex + 1]?.[editedIndex] ?? 0;
                const nextEditedLength = lengths[originalIndex]?.[editedIndex + 1] ?? 0;
                const row = lengths[originalIndex];
                if (row) {
                    row[editedIndex] = Math.max(nextOriginalLength, nextEditedLength);
                }
            }
        }
    }
    const matches = [];
    let originalIndex = 0;
    let editedIndex = 0;
    while (originalIndex < originalWords.length &&
        editedIndex < editedWords.length) {
        if (originalNormalized[originalIndex] &&
            originalNormalized[originalIndex] === editedNormalized[editedIndex]) {
            matches.push({ editedIndex, originalIndex });
            originalIndex += 1;
            editedIndex += 1;
        }
        else if (readCaptionMatchLength(lengths, originalIndex + 1, editedIndex) >=
            readCaptionMatchLength(lengths, originalIndex, editedIndex + 1)) {
            originalIndex += 1;
        }
        else {
            editedIndex += 1;
        }
    }
    return matches;
}
function readCaptionMatchLength(lengths, originalIndex, editedIndex) {
    return lengths[originalIndex]?.[editedIndex] ?? 0;
}
function appendCaptionTimingGap(input) {
    const editedStart = input.previousEditedIndex + 1;
    const originalStart = input.previousOriginalIndex + 1;
    const editedGapWords = input.editedWords.slice(editedStart, input.endEditedIndex);
    const originalGapWords = input.originalWords.slice(originalStart, input.endOriginalIndex);
    if (editedGapWords.length === 0) {
        return;
    }
    for (let index = 0; index < editedGapWords.length; index += 1) {
        const originalWord = originalGapWords[index] ??
            originalGapWords[originalGapWords.length - 1] ??
            input.originalWords[input.previousOriginalIndex] ??
            input.originalWords[input.endOriginalIndex];
        input.retimedWords.push(copyCaptionTiming(originalWord, editedGapWords[index] ?? ""));
    }
}
export const sceneDensityLimits = {
    defaultSecondsPerScene: 4.5,
    maxSecondsPerScene: 6,
    minSecondsPerScene: 2,
    stepSeconds: 0.1,
};
const legacySceneDensitySeconds = {
    balanced: 4.5,
    fewer: 6,
    more: 3.5,
    rapid: 2,
};
export function parseSceneDensity(value) {
    const numericValue = typeof value === "string" && value in legacySceneDensitySeconds
        ? legacySceneDensitySeconds[value]
        : value;
    if (typeof numericValue !== "number" || !Number.isFinite(numericValue)) {
        return null;
    }
    const normalizedValue = Math.round(numericValue * 10) / 10;
    if (Math.abs(numericValue - normalizedValue) > Number.EPSILON * 10 ||
        normalizedValue < sceneDensityLimits.minSecondsPerScene ||
        normalizedValue > sceneDensityLimits.maxSecondsPerScene) {
        return null;
    }
    return normalizedValue;
}
export { defaultMusicTrackId, musicTrackOptions, } from "./data/music-tracks.js";
export { defaultGameplayClipId, findGameplayClipById, gameplayClipOptions, gameplaySeriesCatalog, listSeriesIds, } from "./data/gameplay-clips.js";
export { deterministicRatioFromString } from "./deterministic-ratio.js";
export { renderAutopilotCreditFailureEmail, renderAutopilotSubscriptionRequiredEmail, renderAutopilotStartedEmail, renderPasswordlessSignInCodeEmail, } from "./email-templates.js";
export { getFacelessScriptSanityMessage } from "./faceless-script-sanity.js";
export { defaultTtsModelId, defaultTtsVoiceId, getTtsModelOption, getTtsVoiceOption, isEnabledTtsModelId, isEnabledTtsSelection, isSupportedTtsProviderVoiceId, openRouterTtsModelId, supportedTtsProviderVoices, ttsModelOptions, ttsPreview, ttsVoiceOptions, elevenLabsModelIds, isElevenLabsModelId, getPublicElevenLabsVoiceId, } from "./data/voice-options.js";
export const captionTimingModeOptions = [
    { label: "Word by word", value: "word_by_word" },
    { label: "Balanced", value: "balanced" },
    { label: "Full scene text", value: "full_scene" },
];
export const captionPresetOptions = [
    { label: "Clean", value: "clean" },
    { label: "Bold", value: "bold" },
    { label: "Story", value: "story" },
];
export const captionAnimationOptions = [
    { label: "Pop", value: "pop" },
    { label: "Rise", value: "rise" },
    { label: "Punch", value: "punch" },
    { label: "Word Pop", value: "word_pop" },
];
export const sceneTransitionOptions = [
    { label: "None", value: "none" },
    { label: "Fade", value: "fade" },
    { label: "Slide", value: "slide" },
    { label: "Zoom", value: "zoom" },
    { label: "Wipe", value: "wipe" },
];
export const sceneAnimationOptions = [
    { label: "None", value: "none" },
    { label: "Slow Zoom In", value: "slow_zoom_in" },
    { label: "Slow Zoom Out", value: "slow_zoom_out" },
    { label: "Pan Left", value: "pan_left" },
    { label: "Camera Shake", value: "camera_shake" },
];
export const captionFontFamilyOptions = [
    { label: "Inter", value: "inter" },
    { label: "Montserrat", value: "montserrat" },
    { label: "Anton", value: "anton" },
    { label: "Archivo Black", value: "archivo_black" },
    { label: "Bangers", value: "bangers" },
    { label: "Bebas Neue", value: "bebas_neue" },
    { label: "Luckiest Guy", value: "luckiest_guy" },
    { label: "Oswald", value: "oswald" },
    { label: "Permanent Marker", value: "permanent_marker" },
    { label: "Poppins", value: "poppins" },
    { label: "Roboto Condensed", value: "roboto_condensed" },
    { label: "Rubik Mono One", value: "rubik_mono_one" },
];
export const defaultCaptionStyleSettings = {
    captionTimingMode: "full_scene",
    captionAnimation: "pop",
    captionFontFamily: "montserrat",
    captionTextColor: "#ffffff",
    captionActiveTextColor: "#facc15",
    captionOutlineColor: "#000000",
    captionOutlineWidth: 0,
    captionFontSize: 52,
};
export const facelessImageStylePresets = [
    {
        id: "digital_art",
        label: "Digital Art",
        description: "Stylized painterly concept-art visuals.",
        previewImageSrc: "/images/style-presets/digital-art.png",
        prompt: "stylized digital painting concept-art vertical scene, rich colors, painterly brush textures, atmospheric lighting, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "cinematic",
        label: "Cinematic",
        description: "Movie-like frames with dramatic lighting and depth.",
        previewImageSrc: "/images/style-presets/cinematic.png",
        prompt: "cinematic vertical short-form video still, dramatic lighting, natural depth of field, cohesive color grade, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "photorealistic",
        label: "Photorealistic",
        description: "Real-world documentary look with crisp detail.",
        previewImageSrc: "/images/style-presets/photorealistic.png",
        prompt: "photorealistic documentary-style vertical image, realistic textures, natural light, true-to-life color, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "anime",
        label: "Anime",
        description: "Clean anime-inspired scene composition.",
        previewImageSrc: "/images/style-presets/anime.png",
        prompt: "anime-inspired vertical illustration, clean linework, expressive lighting, vivid color palette, cinematic composition, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "pixar",
        label: "Pixar",
        description: "Expressive stylized 3D animation look with cinematic warmth.",
        previewImageSrc: "/images/style-presets/pixar.png",
        prompt: "Pixar-inspired stylized 3D animated-film vertical scene, clearly non-photorealistic and not live action, expressive cartoon characters with appealing exaggerated proportions and facial features, smooth simplified materials, clean rounded shapes, warm cinematic lighting, polished global illumination, rich color harmony, whimsical storytelling mood, detailed stylized environment, no realistic human photography, no text, no captions, no logos, no UI",
    },
    {
        id: "film_noir",
        label: "Film Noir",
        description: "Moody high-contrast black-and-white vibe.",
        previewImageSrc: "/images/style-presets/film-noir.png",
        prompt: "film noir vertical still, black-and-white high contrast, deep shadows, dramatic practical light, gritty atmosphere, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "lego",
        label: "Lego",
        description: "Brick-built toy world with playful cinematic staging.",
        previewImageSrc: "/images/style-presets/lego.png",
        prompt: "LEGO-inspired vertical scene with minifigure subjects, realistic cinematic composition and natural perspective, environments built from LEGO bricks but shaped like normal real-world locations, restrained color palette with mostly neutral and believable tones, only subtle accent colors, moderate stud visibility and plastic texture, avoid oversized blocky geometry and avoid rainbow color clutter, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "comic_book",
        label: "Comic Book",
        description: "Bold illustrated panels with strong outlines.",
        previewImageSrc: "/images/style-presets/comic-book.png",
        prompt: "comic book illustration vertical frame, bold ink outlines, halftone texture, dynamic composition, punchy colors, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "noir_comic",
        label: "Noir Comic",
        description: "Dark, eerie comic-thriller frames with dramatic contrast.",
        previewImageSrc: "/images/style-presets/noir-comic.png",
        prompt: "dark noir comic illustration vertical frame, eerie night atmosphere, dramatic high contrast shadows, gritty inked linework, unsettling facial expressions, moody cinematic framing, muted cool palette with selective neon accents, detailed environment, no text, no captions, no logos, no UI",
    },
    {
        id: "minimal_stickman",
        label: "Doodle Comic",
        description: "Expressive stick-figure web-comic scenes with bright, clean framing.",
        previewImageSrc: "/images/style-presets/doodle-comic.png",
        prompt: "polished doodle-comic vertical short-form illustration, expressive round-headed stick-figure characters with simple bodies, big readable facial expressions, clean thick black outlines, smooth digital cartoon linework, bright flat colors with subtle cel shading, playful detailed environments that clearly support the narration, wide readable composition with strong subject focus, whimsical what-if explainer energy, comic motion lines and impact shapes when action is present, occasional simple props, animals, vehicles, nature, or surreal objects drawn in the same clean cartoon style, crisp white, sky-blue, pastel, or scenic backgrounds instead of empty gray backdrops, high readability with uncluttered composition, no text, no captions, no logos, no watermarks, no UI",
    },
];
export const defaultFacelessImageStylePresetId = "digital_art";
const facelessImageStylePresetById = new Map(facelessImageStylePresets.map((preset) => [preset.id, preset]));
export function findFacelessImageStylePresetById(id) {
    return facelessImageStylePresetById.get(id);
}
export function getFacelessImageStylePresetById(id) {
    const match = typeof id === "string"
        ? findFacelessImageStylePresetById(id.trim())
        : undefined;
    return (match ??
        facelessImageStylePresetById.get(defaultFacelessImageStylePresetId) ??
        facelessImageStylePresets[0]);
}
export const socialPlatforms = ["INSTAGRAM", "TIKTOK", "YOUTUBE", "FACEBOOK"];
export const autopilotNichePresets = [
    {
        id: "motivation",
        label: "Motivation",
        icon: "💪",
        description: "Create motivational videos with powerful quotes and life advice for go-getters. Focus on morning motivation, productivity, and success mindset.",
        narrowAngleExample: "Morning discipline stories for founders rebuilding momentum after a setback.",
        targetAudienceExample: "Ambitious solo founders and creators who need a hard reset before work.",
        episodeCenterRuleExample: "Each reel centers on one practical mindset shift tied to a vivid everyday moment.",
    },
    {
        id: "finance",
        label: "Finance",
        icon: "💰",
        description: "Create educational finance videos about investing, saving money, building wealth, and financial literacy for beginners.",
        narrowAngleExample: "Beginner wealth-building lessons through simple paycheck and budget scenarios.",
        targetAudienceExample: "Young adults with steady income who feel behind financially.",
        episodeCenterRuleExample: "Each reel centers on one money habit, mistake, or investing concept.",
    },
    {
        id: "wellness",
        label: "Wellness",
        icon: "🧘",
        description: "Create wellness content about meditation, self-care, mental health tips, and healthy lifestyle habits.",
        narrowAngleExample: "Gentle nervous-system resets for people who are constantly overstimulated.",
        targetAudienceExample: "Busy professionals who want realistic self-care without a full lifestyle overhaul.",
        episodeCenterRuleExample: "Each reel centers on one calming habit, reflection, or tiny daily ritual.",
    },
    {
        id: "facts",
        label: "Facts",
        icon: "📚",
        description: "Share fascinating historical facts and little-known stories from history that will surprise viewers.",
        narrowAngleExample: "Little-known turning points from ordinary people during major historical events.",
        targetAudienceExample: "Curious history fans who like surprising stories more than textbook summaries.",
        episodeCenterRuleExample: "Each reel centers on one historical fact, event, artifact, or forgotten person.",
    },
    {
        id: "scary",
        label: "Scary",
        icon: "👻",
        description: "Tell creepy horror stories and scary tales with suspenseful narration.",
        narrowAngleExample: "Supernatural encounters in abandoned 1800s buildings, told like found testimony.",
        targetAudienceExample: "Horror fans who prefer slow dread and atmosphere over gore.",
        episodeCenterRuleExample: "Each reel centers on one scary place, entity, object, or encounter.",
    },
    {
        id: "true_crime",
        label: "True Crime",
        icon: "🔎",
        description: "Cover true crime cases with investigative storytelling and factual details.",
        narrowAngleExample: "Immersive bystander-perspective stories from lesser-known solved cases.",
        targetAudienceExample: "True crime viewers who want factual, respectful storytelling without sensationalism.",
        episodeCenterRuleExample: "Each reel centers on one incident, clue, timeline twist, or investigative mistake.",
    },
    {
        id: "science",
        label: "Science",
        icon: "🔬",
        description: "Explain fascinating science concepts in simple, engaging ways.",
        narrowAngleExample: "Everyday physics explained through objects people see on their commute.",
        targetAudienceExample: "Curious non-scientists who like simple explanations and surprising examples.",
        episodeCenterRuleExample: "Each reel centers on one science concept, experiment, discovery, or natural phenomenon.",
    },
    {
        id: "productivity",
        label: "Productivity",
        icon: "⚡",
        description: "Share productivity tips, time management strategies, and life hacks to help viewers work smarter and achieve their goals.",
        narrowAngleExample: "Time-saving systems for blue collar workers trying to protect family time.",
        targetAudienceExample: "Shift workers and tradespeople who feel stretched thin during the week.",
        episodeCenterRuleExample: "Each reel centers on one tactic, decision rule, checklist, or scheduling habit.",
    },
];
export const redditCommentMaxLength = 8000;
export const facelessScriptGenerationLimits = {
    minTargetDurationSeconds: 30,
    maxTargetDurationSeconds: 120,
    defaultTargetDurationSeconds: 60,
    maxDescriptionLength: 500,
};
export const quoteRuleConstants = {
    WORDS_PER_MINUTE: 150,
    MINIMUM_JOB_CREDITS: 1,
    REDDIT_COMMENTS_MINIMUM_JOB_CREDITS: 6,
    TEXT_MESSAGES_MINIMUM_JOB_CREDITS: 6,
    FACELESS_CREDIT_COST_MULTIPLIER: 1,
    FACELESS_BASE_RENDER_CREDITS: 0,
    FACELESS_VOICE_BLOCK_CREDITS: 0,
    FACELESS_IMAGE_CREDITS_PER_SCENE: 2,
    FACELESS_SCRIPT_GENERATION_CREDITS: 1,
    FACELESS_VISUAL_ANCHOR_CREDITS: 2,
    FACELESS_SECONDS_PER_VOICE_BLOCK: 15,
    REDDIT_COMMENTS_CREDIT_COST_MULTIPLIER: 1,
    REDDIT_COMMENTS_BASE_RENDER_CREDITS: 0,
    REDDIT_COMMENTS_VOICE_BLOCK_CREDITS: 0,
    REDDIT_SECONDS_PER_VOICE_BLOCK: 15,
    REDDIT_MAX_ESTIMATED_SECONDS: 300,
    FACELESS_DURATION_SCALE: 1.06,
    DRAFT_TAIL_PADDING_MS: 1000,
    REDDIT_NARRATION_DURATION_SCALE: 0.88,
    REDDIT_SCENE_GAP_MS: 500,
    REDDIT_TAIL_MS: 1000,
    FACELESS_MIN_SCENES: 3,
    FACELESS_MAX_SCENES: 30,
};
export function getDefaultModelCreditCosts() {
    return {
        ttsCreditsPerThousandCharacters: Object.fromEntries(ttsModelOptions.map((model) => {
            if (model.billing.type !== "input_character") {
                return [model.id, 0];
            }
            return [model.id, roundCredits(model.billing.usdPerCharacter * 100_000)];
        })),
        videoCreditsPerSecond: Object.fromEntries(facelessMotionVideoModelOptions.map((model) => [
            model.id,
            Object.fromEntries(Object.entries(model.priceUsdPerSecondByResolution).map(([resolution, priceUsd]) => [resolution, roundCredits("defaultCreditsPerSecond" in model ? model.defaultCreditsPerSecond : selectedVideoRate(model.id, resolution, priceUsd) * 100)])),
        ])),
        videoInputCreditsPerScene: Object.fromEntries(facelessMotionVideoModelOptions.map((model) => [
            model.id,
            "inputCreditsPerScene" in model ? model.inputCreditsPerScene : 0,
        ])),
    };
}
export const videoStatuses = [
    "generating",
    "draft_ready",
    "rendering",
    "complete",
    "published",
    "failed",
];
export const stripeExtensionCollections = {
    customers: "users",
    products: "stripeProducts",
    config: "stripeConfig",
};
export const firestoreCollectionNames = {
    authEmailCodeChallenges: "authEmailCodeChallenges",
    authEmailCodeRateLimits: "authEmailCodeRateLimits",
    autopilotRuns: "autopilotRuns",
    autopilots: "autopilots",
    creditLedger: "creditLedger",
    checkoutReminders: "checkoutReminders",
    generationJobs: "generationJobs",
    jobs: "jobs",
    operationalAlerts: "operationalAlerts",
    providerCapabilityCache: "providerCapabilityCache",
    renderJobs: "renderJobs",
    sceneMotionJobs: "sceneMotionJobs",
    socialAccounts: "socialAccounts",
    socialPublishJobs: "socialPublishJobs",
    users: "users",
    videos: "videos",
};
export const defaultStarterCredits = 30;
export const planEntitlements = {
    free: {
        activeAutopilots: 1,
        connectedSocialAccounts: 1,
    },
    starter: {
        activeAutopilots: 1,
        connectedSocialAccounts: 1,
    },
    creator: {
        activeAutopilots: 4,
        connectedSocialAccounts: 3,
    },
    pro: {
        activeAutopilots: null,
        connectedSocialAccounts: null,
    },
};
export function getPlanEntitlements(planId) {
    return planEntitlements[planId];
}
export function isPlanLimitUnlimited(limit) {
    return limit === null;
}
export function isPlanLimitReached(limit, currentCount) {
    return !isPlanLimitUnlimited(limit) && currentCount >= limit;
}
export function formatPlanLimit(limit, singularLabel, pluralLabel = `${singularLabel}s`) {
    if (isPlanLimitUnlimited(limit)) {
        return `Unlimited ${pluralLabel}`;
    }
    const label = limit === 1 ? singularLabel : pluralLabel;
    return `${limit} ${label}`;
}
export function formatPlanEntitlementFeatures(planId) {
    const entitlements = getPlanEntitlements(planId);
    return [
        formatPlanLimit(entitlements.connectedSocialAccounts, "connected social account"),
        formatPlanLimit(entitlements.activeAutopilots, "active autopilot"),
    ];
}
export const stripeMetadataKeys = {
    credits: "reelmagicCreditAmount",
    kind: "reelmagicOfferKind",
    offerKey: "reelmagicOfferKey",
    planId: "reelmagicPlanId",
};
export const billingOfferDefinitions = [
    {
        key: "plan_starter_monthly",
        kind: "subscription",
        label: "Starter",
        headline: "First publishing rhythm",
        description: "For early creators validating formats and shipping consistently each month.",
        credits: 1400,
        planId: "starter",
        interval: "month",
        badge: null,
        featured: false,
    },
    {
        key: "plan_creator_monthly",
        kind: "subscription",
        label: "Creator",
        headline: "Reliable weekly output",
        description: "For solo operators and creators who need more room for regular production.",
        credits: 3000,
        planId: "creator",
        interval: "month",
        badge: "Popular",
        featured: true,
    },
    {
        key: "plan_pro_monthly",
        kind: "subscription",
        label: "Pro",
        headline: "Higher-volume publishing",
        description: "For teams and power users running larger production queues each month.",
        credits: 6500,
        planId: "pro",
        interval: "month",
        badge: null,
        featured: false,
    },
    {
        key: "plan_starter_annual",
        kind: "subscription",
        label: "Starter",
        headline: "First publishing rhythm",
        description: "For early creators validating formats and shipping consistently each month.",
        credits: 1400,
        planId: "starter",
        interval: "year",
        badge: null,
        featured: false,
    },
    {
        key: "plan_creator_annual",
        kind: "subscription",
        label: "Creator",
        headline: "Reliable weekly output",
        description: "For solo operators and creators who need more room for regular production.",
        credits: 3000,
        planId: "creator",
        interval: "year",
        badge: "Popular",
        featured: true,
    },
    {
        key: "plan_pro_annual",
        kind: "subscription",
        label: "Pro",
        headline: "Higher-volume publishing",
        description: "For teams and power users running larger production queues each month.",
        credits: 6500,
        planId: "pro",
        interval: "year",
        badge: null,
        featured: false,
    },
    {
        key: "topup_300",
        kind: "top_up",
        label: "300 credits",
        headline: "Quick boost",
        description: "Add credits when you need a little extra runway this billing cycle.",
        credits: 300,
        planId: null,
        interval: null,
        badge: null,
        featured: false,
    },
    {
        key: "topup_700",
        kind: "top_up",
        label: "700 credits",
        headline: "Creator pack",
        description: "The sweet spot for heavier posting weeks without changing plans.",
        credits: 700,
        planId: null,
        interval: null,
        badge: null,
        featured: false,
    },
    {
        key: "topup_1700",
        kind: "top_up",
        label: "1,700 credits",
        headline: "Power pack",
        description: "For launch windows and bulk production when you need maximum headroom.",
        credits: 1700,
        planId: null,
        interval: null,
        badge: null,
        featured: false,
    },
];
export const billingGrantMappings = billingOfferDefinitions.map((offer) => ({
    offerKey: offer.key,
    kind: offer.kind,
    planId: offer.planId,
    credits: offer.credits,
}));
export const creditLedgerEventTypes = [
    "starter_grant",
    "reservation",
    "charge",
    "refund",
    "top_up",
    "renewal",
    "adjustment",
];
export const launchTemplates = [
    {
        value: "faceless_video",
        label: "Faceless Video",
        summary: "AI-scaffolded scenes with narration, captions, and music.",
        createHref: "/app/create/faceless-video",
    },
    {
        value: "reddit_comments",
        label: "Reddit Comments",
        summary: "Read comments from a Reddit post over background footage.",
        createHref: "/app/create/reddit-comments",
    },
    {
        value: "text_messages",
        label: "Text Messages",
        summary: "Two-person iMessage-style conversations over background footage.",
        createHref: "/app/create/text-messages",
    },
];
export function getBillingOfferDefinition(offerKey) {
    return billingOfferDefinitions.find((offer) => offer.key === offerKey);
}
export function getBillingGrantMapping(offerKey) {
    return billingGrantMappings.find((offer) => offer.offerKey === offerKey);
}
export function readStripeBillingMetadata(metadata) {
    const offerKey = metadata?.[stripeMetadataKeys.offerKey];
    const offerKind = metadata?.[stripeMetadataKeys.kind];
    const planId = metadata?.[stripeMetadataKeys.planId];
    return {
        reelmagicCreditAmount: metadata?.[stripeMetadataKeys.credits] ?? null,
        reelmagicOfferKey: typeof offerKey === "string" ? offerKey : null,
        reelmagicOfferKind: offerKind === "subscription" || offerKind === "top_up" ? offerKind : null,
        reelmagicPlanId: planId === "free" ||
            planId === "starter" ||
            planId === "creator" ||
            planId === "pro"
            ? planId
            : null,
    };
}
export function getCreditsFromStripeMetadata(metadata) {
    const value = readStripeBillingMetadata(metadata).reelmagicCreditAmount;
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === "string") {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
}
const planRank = {
    free: 0,
    starter: 1,
    creator: 2,
    pro: 3,
};
export function isActiveStripeSubscriptionStatus(status) {
    return status === "active" || status === "trialing";
}
function getStripeSubscriptionSortValue(subscription) {
    const candidate = subscription.current_period_start ?? subscription.created ?? null;
    if (!candidate) {
        return Number.NEGATIVE_INFINITY;
    }
    const parsed = Date.parse(candidate);
    return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
}
export function deriveCurrentPlanIdFromStripeSubscriptions(subscriptions) {
    return subscriptions
        .filter((subscription) => isActiveStripeSubscriptionStatus(subscription.status))
        .map((subscription) => {
        const metadata = readStripeBillingMetadata(subscription.metadata);
        const mapping = (metadata.reelmagicOfferKey &&
            getBillingGrantMapping(metadata.reelmagicOfferKey)) ||
            undefined;
        return metadata.reelmagicPlanId ?? mapping?.planId ?? "free";
    })
        .reduce((highestPlanId, planId) => planRank[planId] > planRank[highestPlanId] ? planId : highestPlanId, "free");
}
/** Billing cadence for the user's primary active subscription, or `null` if none / unknown. */
export function deriveBillingCycleIntervalFromStripeSubscriptions(subscriptions) {
    const latestActiveSubscription = [...subscriptions]
        .filter((subscription) => isActiveStripeSubscriptionStatus(subscription.status))
        .sort((left, right) => getStripeSubscriptionSortValue(right) -
        getStripeSubscriptionSortValue(left))[0];
    if (!latestActiveSubscription) {
        return null;
    }
    const metadata = readStripeBillingMetadata(latestActiveSubscription.metadata);
    const offerKey = metadata.reelmagicOfferKey;
    if (typeof offerKey === "string" && offerKey.endsWith("_annual")) {
        return "year";
    }
    if (typeof offerKey === "string" && offerKey.endsWith("_monthly")) {
        return "month";
    }
    const definition = offerKey ? getBillingOfferDefinition(offerKey) : undefined;
    if (definition?.interval === "year" || definition?.interval === "month") {
        return definition.interval;
    }
    return null;
}
export function buildBillingCatalog(products) {
    const syncedOffers = new Map();
    for (const product of products) {
        const productMetadata = readStripeBillingMetadata(product.metadata);
        for (const price of product.prices) {
            const priceMetadata = readStripeBillingMetadata(price.metadata);
            const offerKey = priceMetadata.reelmagicOfferKey ?? productMetadata.reelmagicOfferKey;
            const definition = offerKey
                ? getBillingOfferDefinition(offerKey)
                : undefined;
            if (!definition || !price.active || !product.active) {
                continue;
            }
            const existing = syncedOffers.get(definition.key);
            const credits = getCreditsFromStripeMetadata(price.metadata) ??
                getCreditsFromStripeMetadata(product.metadata) ??
                definition.credits;
            const catalogPrice = {
                id: price.id,
                currency: price.currency,
                unitAmount: price.unit_amount,
                type: price.type,
                interval: price.interval,
                intervalCount: price.interval_count,
                description: price.description ?? null,
            };
            const nextOffer = existing ?? {
                ...definition,
                credits,
                productId: product.id,
                synced: true,
                prices: [],
            };
            nextOffer.prices = [...nextOffer.prices, catalogPrice].sort((left, right) => {
                return ((left.unitAmount ?? Number.MAX_SAFE_INTEGER) -
                    (right.unitAmount ?? Number.MAX_SAFE_INTEGER));
            });
            syncedOffers.set(definition.key, nextOffer);
        }
    }
    return billingOfferDefinitions.map((definition) => {
        return (syncedOffers.get(definition.key) ?? {
            ...definition,
            productId: null,
            synced: false,
            prices: [],
        });
    });
}
export function countWords(value) {
    const normalized = value.trim();
    if (!normalized) {
        return 0;
    }
    return normalized.split(/\s+/u).length;
}
function buildTtsQuoteParts(segments) {
    const charactersByModel = new Map();
    for (const segment of segments) {
        charactersByModel.set(segment.modelId, (charactersByModel.get(segment.modelId) ?? 0) +
            (isElevenLabsModelId(segment.modelId) ? Array.from(segment.text).length : segment.text.length));
    }
    const lines = [];
    const estimates = [];
    for (const [modelId, inputCharacters] of charactersByModel) {
        const model = getTtsModelOption(modelId);
        if (!model || model.availability !== "enabled") {
            throw new Error(`TTS model is not enabled: ${modelId}`);
        }
        if (model.billing.type !== "input_character") {
            throw new Error(`TTS billing type is not supported: ${model.billing.type}`);
        }
        const estimatedProviderCostUsd = inputCharacters * model.billing.usdPerCharacter;
        const unitCredits = roundCredits(getTtsCreditsPerThousandCharacters(modelId) / 1000);
        const subtotalCredits = roundCredits(inputCharacters * unitCredits);
        lines.push({
            label: `${model.label} voiceover`,
            quantity: inputCharacters,
            unitCredits,
            subtotalCredits,
        });
        estimates.push({
            billingType: "input_character",
            estimatedProviderCostUsd,
            inputUnits: inputCharacters,
            modelId,
            subtotalCredits,
            usdPerUnit: model.billing.usdPerCharacter,
        });
    }
    return { estimates, lines };
}
export function getTtsCreditsPerThousandCharacters(modelId) {
    const model = getTtsModelOption(modelId);
    if (!model || model.billing.type !== "input_character")
        throw new Error(`Character pricing is not available for TTS model: ${modelId}`);
    if (!runtimeModelCreditCosts)
        return roundCredits(model.billing.usdPerCharacter * 100_000);
    const rate = runtimeModelCreditCosts.ttsCreditsPerThousandCharacters[modelId];
    if (typeof rate !== "number" || !Number.isFinite(rate) || rate < 0)
        throw new Error(`A valid credit rate is required for TTS model: ${modelId}`);
    return rate;
}
export function estimateDurationMsFromWordCount(wordCount) {
    if (!Number.isFinite(wordCount) || wordCount <= 0) {
        return 0;
    }
    return Math.round((wordCount * 60000) / quoteRuleConstants.WORDS_PER_MINUTE);
}
export function estimateTargetWordCountForFacelessScript(durationSeconds) {
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
        return 0;
    }
    return Math.max(20, Math.round((durationSeconds * quoteRuleConstants.WORDS_PER_MINUTE) / 60));
}
export function estimateSceneCountForFacelessVideo(estimatedDurationMs, density) {
    const secondsPerScene = parseSceneDensity(density);
    if (secondsPerScene === null) {
        throw new Error("Scene pacing must be between 2 and 6 seconds per scene in 0.1-second steps.");
    }
    const estimatedDurationSeconds = Math.max(estimatedDurationMs, 0) / 1000;
    const estimatedRaw = Math.ceil(estimatedDurationSeconds / secondsPerScene);
    return Math.min(quoteRuleConstants.FACELESS_MAX_SCENES, Math.max(quoteRuleConstants.FACELESS_MIN_SCENES, estimatedRaw || 0));
}
export function buildFacelessVideoQuote(input) {
    const visualMode = input.visualMode ?? "image";
    const playbackSpeed = typeof input.playbackSpeed === "number" &&
        Number.isFinite(input.playbackSpeed)
        ? Math.min(2.5, Math.max(1, input.playbackSpeed))
        : 1;
    const wordCount = countWords(input.script);
    const estimatedDurationMs = Math.round(estimateDurationMsFromWordCount(wordCount) *
        quoteRuleConstants.FACELESS_DURATION_SCALE);
    const estimatedSceneCount = estimateSceneCountForFacelessVideo(estimatedDurationMs, input.sceneDensity);
    const tts = buildTtsQuoteParts([
        { modelId: input.ttsModelId, text: input.script },
    ]);
    const lines = [
        {
            label: "Base render",
            quantity: 1,
            unitCredits: quoteRuleConstants.FACELESS_BASE_RENDER_CREDITS,
            subtotalCredits: quoteRuleConstants.FACELESS_BASE_RENDER_CREDITS,
        },
        ...tts.lines,
    ];
    lines.push({
        label: "Estimated scene images",
        quantity: estimatedSceneCount,
        unitCredits: quoteRuleConstants.FACELESS_IMAGE_CREDITS_PER_SCENE,
        subtotalCredits: estimatedSceneCount *
            quoteRuleConstants.FACELESS_IMAGE_CREDITS_PER_SCENE,
    });
    if (visualMode === "motion") {
        const estimatedRenderedSceneDurationSeconds = Math.ceil(Math.max(1, estimatedDurationMs / playbackSpeed / Math.max(1, estimatedSceneCount)) / 1000);
        const motionVideoCreditsPerScene = getFacelessMotionVideoCreditsPerScene({
            durationSeconds: estimatedRenderedSceneDurationSeconds,
            ...(input.motionVideoModelId
                ? { modelId: input.motionVideoModelId }
                : {}),
            ...(input.motionVideoResolution
                ? { resolution: input.motionVideoResolution }
                : {}),
        });
        lines.push({
            label: "Estimated scene videos",
            quantity: estimatedSceneCount,
            unitCredits: motionVideoCreditsPerScene,
            subtotalCredits: roundCredits(estimatedSceneCount * motionVideoCreditsPerScene),
        });
    }
    const baseCredits = lines.reduce((sum, line) => sum + line.subtotalCredits, 0);
    const scaledCredits = Math.ceil(baseCredits * quoteRuleConstants.FACELESS_CREDIT_COST_MULTIPLIER);
    const totalCredits = Math.max(quoteRuleConstants.MINIMUM_JOB_CREDITS, scaledCredits);
    return {
        templateType: "faceless_video",
        totalCredits,
        estimatedDurationMs,
        estimatedSceneCount,
        lines,
        ttsEstimates: tts.estimates,
    };
}
export function buildRedditCommentsQuote(input) {
    const assembled = [input.postTitle, ...input.selectedCommentTexts]
        .join(" ")
        .trim();
    const wordCount = countWords(assembled);
    const estimatedNarrationMs = Math.round(estimateDurationMsFromWordCount(wordCount) *
        quoteRuleConstants.REDDIT_NARRATION_DURATION_SCALE);
    const estimatedSceneCount = Math.max(1, input.selectedCommentTexts.length + 1);
    const estimatedGapMs = Math.max(0, estimatedSceneCount - 1) *
        quoteRuleConstants.REDDIT_SCENE_GAP_MS +
        quoteRuleConstants.REDDIT_TAIL_MS;
    const estimatedDurationMs = estimatedNarrationMs + estimatedGapMs;
    const tts = buildTtsQuoteParts([
        { modelId: input.ttsModelId, text: assembled },
    ]);
    const lines = [
        {
            label: "Base render",
            quantity: 1,
            unitCredits: quoteRuleConstants.REDDIT_COMMENTS_BASE_RENDER_CREDITS,
            subtotalCredits: quoteRuleConstants.REDDIT_COMMENTS_BASE_RENDER_CREDITS,
        },
        ...tts.lines,
    ];
    const baseCredits = lines.reduce((sum, line) => sum + line.subtotalCredits, 0);
    const scaledCredits = Math.ceil(baseCredits * quoteRuleConstants.REDDIT_COMMENTS_CREDIT_COST_MULTIPLIER);
    const totalCredits = Math.max(quoteRuleConstants.REDDIT_COMMENTS_MINIMUM_JOB_CREDITS, scaledCredits);
    return {
        templateType: "reddit_comments",
        totalCredits,
        estimatedDurationMs,
        lines,
        ttsEstimates: tts.estimates,
    };
}
export function buildTextMessagesQuote(input) {
    const assembled = input.segments.map((segment) => segment.text).join(" ").trim();
    const wordCount = countWords(assembled);
    const estimatedNarrationMs = Math.round(estimateDurationMsFromWordCount(wordCount) *
        quoteRuleConstants.REDDIT_NARRATION_DURATION_SCALE);
    const estimatedSceneCount = Math.max(1, input.segments.length);
    const estimatedGapMs = Math.max(0, estimatedSceneCount - 1) *
        quoteRuleConstants.REDDIT_SCENE_GAP_MS +
        quoteRuleConstants.REDDIT_TAIL_MS;
    const estimatedDurationMs = estimatedNarrationMs + estimatedGapMs;
    const tts = buildTtsQuoteParts(input.segments.map((segment) => ({
        modelId: segment.ttsModelId,
        text: segment.text,
    })));
    const lines = [
        {
            label: "Base render",
            quantity: 1,
            unitCredits: quoteRuleConstants.REDDIT_COMMENTS_BASE_RENDER_CREDITS,
            subtotalCredits: quoteRuleConstants.REDDIT_COMMENTS_BASE_RENDER_CREDITS,
        },
        ...tts.lines,
    ];
    const baseCredits = lines.reduce((sum, line) => sum + line.subtotalCredits, 0);
    const scaledCredits = Math.ceil(baseCredits * quoteRuleConstants.REDDIT_COMMENTS_CREDIT_COST_MULTIPLIER);
    const totalCredits = Math.max(quoteRuleConstants.TEXT_MESSAGES_MINIMUM_JOB_CREDITS, scaledCredits);
    return {
        templateType: "text_messages",
        totalCredits,
        estimatedDurationMs,
        lines,
        ttsEstimates: tts.estimates,
    };
}
export * from "./email-templates.js";
